import { makeStyles } from '@material-ui/core'

/** One column constant for header, row and skeleton (§2). */
const COLUMNS = '7fr 6fr 4fr 4fr 4fr 1fr'

const useStyles = makeStyles((theme) => ({
  root: {},
  tableHead: {
    // Grid children default to min-width:auto, which means a long unbreakable
    // string sets the column's floor and pushes every other column aside — one
    // encoded identifier was enough to wreck the whole row. min-width:0 lets the
    // track shrink to its fr share, and overflow-wrap breaks the token inside its
    // own cell instead of outside it.
    '& > div': {
      minWidth: 0,
      overflowWrap: 'anywhere',
      // Same fix as the two ticket tables, and this tab needs it for the same
      // reason: the first cell mixes an inline <bdi> (the policy id), a block
      // <Typography variant="caption"> (the version) and up to two Chips
      // (Override, Retired). Without flex the caption drops to its own line and
      // the chips wrap under it, so a policy carrying either chip is two or
      // three lines tall while its neighbours are one.
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 4
    },
    width: '100%',
    display: 'grid',
    gridTemplateColumns: COLUMNS,
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12
  },
  tableRow: {
    // Grid children default to min-width:auto, which means a long unbreakable
    // string sets the column's floor and pushes every other column aside — one
    // encoded identifier was enough to wreck the whole row. min-width:0 lets the
    // track shrink to its fr share, and overflow-wrap breaks the token inside its
    // own cell instead of outside it.
    '& > div': {
      minWidth: 0,
      overflowWrap: 'anywhere',
      // Same fix as the two ticket tables, and this tab needs it for the same
      // reason: the first cell mixes an inline <bdi> (the policy id), a block
      // <Typography variant="caption"> (the version) and up to two Chips
      // (Override, Retired). Without flex the caption drops to its own line and
      // the chips wrap under it, so a policy carrying either chip is two or
      // three lines tall while its neighbours are one.
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 4
    },
    display: 'grid',
    gridTemplateColumns: COLUMNS,
    minHeight: 72,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    paddingLeft: 12,
    marginBottom: 4,
    transition: 'background-color 0.3s ease-in-out',
    '&:hover': { backgroundColor: theme.palette.background.paper }
  },
  // A retired version stays legible. The "Retired" Chip carries the meaning in
  // text; the dimming only de-emphasises, so it must not push the secondary
  // text below contrast minimums the way 0.6 did.
  retiredRow: { opacity: 0.85 },
  actionsCell: { display: 'flex', justifyContent: 'flex-end' },
  skeleton: { marginInlineEnd: theme.spacing(2) },
  noDataImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4)
  }
}))

export default useStyles
